import Vue from "vue";
import { Component } from "vue-property-decorator";
import { FetchWrapper } from "../../infrastructure/fetch-wrapper";
import { ReportServices } from "../../scripts/ah.mb.report-services";
import { modelServices } from "../../scripts/ah.mb.ui.model-services";
import { ModelNotifier } from "../../scripts/model-notifier";

export interface IDashboardInfo {
    id: number;
    name: string;
    lastChangeStr: string;
    lastChangedByName: string;
    url: string;
}


@Component
export default class DashboardList extends Vue {

    // Model change observer
    private modelObserver = new ModelNotifier();

    modelServices = new modelServices(this.modelObserver);
    reportServices = new ReportServices(this.modelObserver);

    value = new Array<IDashboardInfo>();
    isBusy = false;

    refreshDashboardList() {
        this.isBusy = true;
        FetchWrapper.fetch("/api/1.0/query/getdashboardlist", { method: "get" })
            .then(response => response.json())
            .then(response => this.value = response)
            .finally(() => this.isBusy = false);

    }

    mounted() {
        this.refreshDashboardList();
    }

    tabChanged(tabName: "tools" | "viewer") {

    }

   onOpenDashboardClick(value: IDashboardInfo) {

        this.$router.push({ name: "embedded-dashboard", params: { "dashboardId": value.id.toString() } });
    }

    onEditDashboardClick(value: IDashboardInfo) {
        window.open(value.url, '_blank').focus();

        // `https://superset.arrowheadmodeling.com/superset/dashboard/${value.id}`
        
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/dashboard-list/dashboard-list.ts